import { Expose, plainToClassFromExist } from 'class-transformer';

export class SnStreamSources {
  @Expose()
  public mp4: string;

  @Expose()
  public hls: string;

  @Expose()
  public dash: string;

  @Expose()
  public rtmp: string;

  @Expose()
  public rtsp: string;

  @Expose()
  public sldp: string;

  @Expose()
  public fmp4: string;

  @Expose()
  public jpeg: string;

  @Expose()
  public flv: string;

  @Expose()
  public headers: any;

  @Expose()
  public wssEvents: string;

  @Expose()
  public wssRtsp: string;

  @Expose()
  public ws: string;

  constructor(data: any = {}) {
    plainToClassFromExist(this, data, { strategy: 'excludeAll' });
  }
}
